export default __webpack_public_path__ + "static/media/Logo_mysql.f251faee.png";